import { inject } from '@angular/core';
import { AuthApi } from '../api/auth.api';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { AUTH_RC, AUTHORIZED_RC } from '@core/constants/routes.constants';

export const canMatchUnauthorized: CanMatchFn = (): boolean | UrlTree => {
  const router = inject(Router);
  const authApi = inject(AuthApi);

  return authApi.isAuthorized() ? router.createUrlTree([AUTHORIZED_RC.root]) : true;
};

export const canMatchAuthorized: CanMatchFn = (): boolean | UrlTree => {
  const router = inject(Router);
  const authApi = inject(AuthApi);

  if (authApi.isAuthorized()) return true;

  return router.createUrlTree([AUTH_RC.root]);
};